import { render, staticRenderFns } from "./RoomsModal.vue?vue&type=template&id=a3ecccda&"
import script from "./RoomsModal.vue?vue&type=script&lang=js&"
export * from "./RoomsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3ecccda')) {
      api.createRecord('a3ecccda', component.options)
    } else {
      api.reload('a3ecccda', component.options)
    }
    module.hot.accept("./RoomsModal.vue?vue&type=template&id=a3ecccda&", function () {
      api.rerender('a3ecccda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/RoomsModal.vue"
export default component.exports